import { useEffect } from 'react'

import { useSelector } from 'react-redux'

import { msgLowReachReceived } from 'src/Helpers/TagManager/ScheduleEvents'
import {
  getUserCampaignTypeSelector,
  getUserId,
} from 'src/Redux/auth-process/userSlice/selectors'
import { getAmountOfCampaigns } from 'src/Redux/campaignList-process'
import { useBudgetRange } from 'src/Redux/spotifyBudgetRangeApi'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'

export const useScheduleGenres = (): void => {
  const userId = useSelector(getUserId)
  const {
    campaignDetails: scheduledSpotifyCampaign,
    genresList,
    hasSelectedLanguagesWithoutAny,
  } = useSpotifyCampaignStatus()
  const campaignType = useSelector(getUserCampaignTypeSelector)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)
  const { isError: budgetRangeError } = useBudgetRange()

  useEffect(() => {
    if (budgetRangeError && hasSelectedLanguagesWithoutAny) {
      msgLowReachReceived({
        genreList: genresList,
        type: campaignType,
        campaignId: String(scheduledSpotifyCampaign?.id),
        userId: String(userId),
        campaignNumber: amountOfCampaigns,
      })
    }
  }, [
    amountOfCampaigns,
    budgetRangeError,
    campaignType,
    genresList,
    hasSelectedLanguagesWithoutAny,
    scheduledSpotifyCampaign?.id,
    userId,
  ])
}
